import { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'

import { useAuth } from '../../../hooks/auth'

import styles from '../../../styles/bantrab/components/surveyPopup.module.scss'

const DEFAULT_STORAGE_KEY = 'bantrabSurvey2026Dismissed'

const normalizePathname = pathname => {
  if (!pathname) return ''
  const trimmed = pathname.replace(/\/+$/, '')
  return trimmed || '/'
}

const isSurveyHiddenAuthRoute = pathname => {
  const p = normalizePathname(pathname)
  const blocks = ['/auth/signin', '/auth/signup', '/auth/password/recovery']
  return blocks.some(base => p === base || p.startsWith(`${base}/`))
}

const SurveyPopup = ({
  surveyUrl,
  description,
  storageKey,
  showCloseButton
}) => {
  const router = useRouter()
  const auth = useAuth()
  const [hydrated, setHydrated] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  const guestSeesSignupBanner = !(auth && auth.isAuthenticated && auth.user)

  useEffect(() => {
    try {
      setDismissed(sessionStorage.getItem(storageKey) === '1')
    } catch (err) {
      setDismissed(false)
    }
    setHydrated(true)
  }, [storageKey])

  const handleDismiss = useCallback(() => {
    try {
      sessionStorage.setItem(storageKey, '1')
    } catch (err) {
      // ignore quota / private mode
    }
    setDismissed(true)
  }, [storageKey])

  if (!surveyUrl || !hydrated || dismissed) {
    return null
  }

  if (!router.isReady || isSurveyHiddenAuthRoute(router.pathname)) {
    return null
  }

  const bottomClass = guestSeesSignupBanner
    ? styles.bottomAboveSignupBanner
    : styles.bottomDefault

  return (
    <aside
      className={`${styles.wrapper} ${bottomClass}`}
      role="complementary"
      aria-label="Encuesta">
      <div className={styles.card}>
        {showCloseButton ? (
          <button
            type="button"
            className={styles.close}
            onClick={handleDismiss}
            aria-label="Cerrar aviso de encuesta">
            ×
          </button>
        ) : null}
        <h2 className={styles.title}>
          <span className={styles.titlePrefix}>Tu opinión importa</span>
        </h2>
        <p className={styles.description}>{description}</p>
        <a
          className={styles.cta}
          href={surveyUrl}
          target="_blank"
          rel="noopener noreferrer">
          Hacer encuesta →
        </a>
      </div>
    </aside>
  )
}

SurveyPopup.propTypes = {
  surveyUrl: PropTypes.string,
  description: PropTypes.string,
  storageKey: PropTypes.string,
  showCloseButton: PropTypes.bool
}

SurveyPopup.defaultProps = {
  surveyUrl: '',
  description:
    'Queremos mejorar cada día para ti. Responde nuestra encuesta rápida (menos de 1 minuto) y ayúdanos a crear la mejor experiencia.',
  storageKey: DEFAULT_STORAGE_KEY,
  showCloseButton: true
}

export default SurveyPopup
